<div class="innerpage-fullwithbanner">
  <h2 class="bighead">My Inquiries<span class="offerstatus">{{rowCount|number}}</span></h2>
  <ul class="bread-crumbs">
    <li><a (click)="_validationService.redirect('/')">Home<span>|</span></a></li>
    <li *ngIf="currentMenu!=''"><span>{{currentMenu}}<span style="padding:8px;">|</span></span></li>
    <li *ngIf="prevPage"><a (click)="_validationService.navigateByUrl(prevPageRouteLink)">{{prevPage}}<span>|</span></a></li>
    <li>My Inquiries</li>
  </ul>
</div>
<div class="featuredproperties section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="row">
      <div class="col-lg-12 ">
        <div class="border-div margin0 table-fixed">
          <div class="floatinghead clearfix">
            <div class="row">
              <div class="form-group margin-bottom-10 col-sm-8">
                <ul class="statuslisting user-listing margin-bottom-0">
                  <li class="transition" style="border: 1px solid #d8d0d0;" *ngFor="let item of filterCount;let i=index" [class.active]="activefilterButton === item.ParameterId" (click)="onSortData(item.ParameterId)">
                    <a href="javascript:void(0);">
                      <h3 [style.color]="colors[i]">{{item.ParameterCount}}</h3>
                      <h4 style="color:black">{{item.ParameterName}}</h4>
                    </a>
                  </li>
                  <li class="transition link-btn-li" (click)="onSortData(0)">
                    <a class="bluelinkunderline" href="javascript:void(0);">View All</a>
                  </li>
                </ul>
              </div>
              <div class="col-sm-4">
                <div class="rightside clearfix">
                  <div class="search-sec">
                    <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                    <i class="fa fa-search icon" aria-hidden="true"></i>
                  </div>
                  <!--<a class="filter btn  btn-circle btn-blue" href="#"><i class="fa fa-filter icon" aria-hidden="true"></i></a>
                  <a class="filter btn  btn-circle btn-green adduserbtn" href="javascript:void(0);"><i class="fa fa-plus icon" aria-hidden="true"></i></a>-->
                </div>
              </div>
            </div>


          </div>
          <div class="table-responsive">
            <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
              <thead>
                <tr>
                  <th style="width:100px" [ngClass]="{'showcell':(this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)),'hide': (!this.authService.IsUserRole(this.authService.UserRole.Admin)&&!this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))}" data-orderable="false">Actions</th>

                  <th class="sticky-left z-100">Prospect</th>
                  <th class="min-width-75">Role</th>
                  <th class="min-width-td">Tenant</th>
                  <th>State</th>
                  <th class="min-width-75">City</th>
                  <!--<th>Property Contact</th>-->
                  <th>Broker</th>
                  <th style="min-width:180px">Comments</th>
                  <th>Inquiry Date</th>
                  <!--<th>Status</th>-->
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let offer of offers; let i = index ">
                  <td class="whitespacenowrap" *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)">
                    <!--<div class="btn-group rightdropdown" dropdown>
                        <button id="button-basic" dropdownToggle type="button" class="view dropdown-toggle"
                                aria-controls="dropdown-basic">
                            <i class="fa fa-cog" aria-hidden="true"></i>
                        </button>
                        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
                            role="menu" aria-labelledby="button-basic">
                            <li role="menuitem" *ngFor="let stype of statusList; let i = index; trackBy: trackByFn"><a class="dropdown-item" href="javascript:void(0);" *ngIf="offer.StatusName!=stype.description" (click)="changeInquiryStatus(stype.id,offer.InquiryId,i,stype.description)">{{stype.description}}</a></li>
                        </ul>
                    </div>-->
                    <a class="remove" tooltip="Remove" href="javascript:void(0);" (click)="openModal(template,'deletemodal',offer.InquiryId,i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                  </td>
                  <td class="sticky-left">

                    <p *ngIf="isAdmin" class="whitespacenowrap"><a href="javascript:void(0);" routerLink="/registered-user-details/" [queryParams]="{principal:offer.Guid,  prevroute:'Listing Inquiries', link : 'inquiry-list?fromMenu=Opportunity'}">{{ offer.LeadName }}</a></p>
                    <p *ngIf="!isAdmin" style="font-weight:600">{{ offer.LeadName }}</p>
                    <p *ngIf="offer.Phone" class="whitespacenowrap">{{ offer.Phone | phone }}</p>
                    <p *ngIf="offer.Email" class="whitespacenowrap">{{offer.Email}}</p>
                  </td>
                  <td>
                    <p>{{ offer.Role }}</p>
                  </td>
                  <td>
                    <p><a href="javascript:void(0);" routerLink="/viewproperty/{{offer.Slug ? offer.Slug : offer.PGuid}}" [queryParams]="{prevroute:'Listing Inquiries',link:router.url}">{{ offer.TenantName }}</a></p>
                  </td>
                  <td>
                    <p>{{ offer.State }}</p>
                  </td>
                  <td>
                    <p>{{ offer.City }}</p>
                  </td>
                  <td>
                    <p>{{ offer.PrimaryContactName }}</p>
                    <p *ngIf="offer.SecondaryContactNames">{{ offer.SecondaryContactNames }}</p>
                  </td>
                  <td class="pos-relative">
                    <p class="ellipsis-text commentpara overflow-visible">
                      {{offer.Comments?.length > 15 ? (offer.Comments.substr(0,15) + '...') :  (offer.Comments ? (offer.Comments):'-')}}
                      <!--Removed container="body" -->
                      <a *ngIf="offer.Comments?.length > 15 " href="javascript:void(0)" class="blue-text view-text" triggers="focus" popover="{{offer.Comments}}"><span>View More</span></a>
                    </p>
                  </td>
                  <td><span *ngIf="offer.InquiryDate">{{convertUTCDateToLocalDate(offer.InquiryDate)| date:'MM/dd/yyyy'}}</span></td>
                  <!--<td><p>{{offer.StatusName}}</td>-->
                  <td>
                    <label class="select">
                      <!--<select class="form-control" #role="ngModel" required [(ngModel)]="userInputModel.UserRoleId">-->
                      <select class="form-control" [(ngModel)]="offer.StatusId" id="status" #status (change)="changeInquiryStatus(offer.StatusId,offer.InquiryId)">
                        <!--<option value="0">--Select--</option>-->
                        <option *ngFor="let stype of statusList" [(ngValue)]="stype.id">{{stype.description}}</option>
                      </select>
                      <i></i>
                    </label>
                  </td>

                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="offers?.length == 0&&!IsLoading ">
                  <td colspan="10" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Inquiry Details</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete  ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="deleteInquiry();modalRef.hide();">Delete</button>
    </div>
  </div>
</ng-template>
